import { SxProps } from '@mui/system'

import { theme } from 'src/providers/ThemeProvider'

type HeaderMenuElements = {
  headerMenuButton: SxProps
}

export const headerMenuStyles: HeaderMenuElements = {
  headerMenuButton: {
    fontFamily: theme.fonts.interFont,
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '22px'
  }
}
